module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "fm-title"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _vm._v("ACKNOWLEDGEMENTS")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The author and the illustrator are equally indebted to their grandfather, G.K. George, for his wondrous tales of far-off times and exotic places that inspired their choice of careers. The author would like to thank many people for their encouragement along the way but especially Marjorie Mandelstam Balzer, Ben Eklof, Felicia Eth, Adlele Lindenmeyr, Alexei Miller, Monty Montee, Saul Morson, Alexander Riasanovsky and Edith Finton Rieber. I am deeply grateful to Marsha Siefert for her critical acumen, technical assistance and above all, for Irina, the Swan."), _c('a', {
    attrs: {
      "id": "page_viii"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6af4a40e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/06_Ack.vue
// module id = 75
// module chunks = 0